<template>
    <div>
        <v-select v-model="subcontractor" ref="subcontractorSelect" label="subcontractor_name" :filterable="false" @search="onSearch" @input="onChange" :options="options" placeholder="Search Subcontractors" :class="{'filter-select': forFilters, 'is-invalid': hasError}">
            <template slot="no-options">
                Search for a Subcontractor by Name or Number...
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.subcontractor_name }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-if="option.subcontractor_name">
                    {{ option.subcontractor_name }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        selectedValues: {
            type: Object,
            default: null
        },

        forFilters: {
            type: Boolean,
            default: false,
        },

        excludeId: {
            type: Number,
        },

        hasError: {
            type: Boolean,
            default: false,
        }
    },

    data: function() {
        return {
            options: [],
            subcontractor: null,
        }
    },

    watch: {
        //Watcher for errors
        hasError(newValue, oldValue){
            //Set it
            this.hasError = newValue;
        },

        selectedValues(newValue, oldValue){
            if(newValue != null && Object.keys(newValue).length > 0 && !this.subcontractor)
            {
                this.options.push(newValue);
                this.subcontractor = newValue;
            }
        }
    },

    methods: {
        //Search
        onSearch: function(searchTerm, searchLoading) {
            //Done loading
            searchLoading(true);

            //Send it
            this.$http.get('/subcontractors/search', {
                    term: searchTerm,
                    excludeId: this.excludeId,
                })
                .then(res => {
                    //Set the data
                    this.options = res.data;

                    //Done loading
                    searchLoading(false);
                });
        },

        onChange: function(subcontractor){
            //Make sure we're not loading
            if (!this.loading)
            {
                //Send it
                this.$emit('vselected', subcontractor);
            }
        },

        setValue(subcontractor){
            this.options.push(subcontractor);
            this.subcontractor = subcontractor;
        },

        clearInput(){
            //Reset All
            this.subcontractor = null;
            this.options = [];
            this.$refs.subcontractorSelect.clearSelection();
        }

    },

    mounted() {
        //Check for null and empty values
        if (this.selectedValues == null || (Object.keys(this.selectedValues).length === 0 && this.selectedValues.constructor === Object))
        {
            this.subcontractor = null;
        }
        else
        {
            this.setValue(this.selectedValues);
        }
    }
}
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 250px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }
</style>
